import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export type ReenviarWhatsappAssinaturaResponse = {
  assinatura: {
    id: number;
    status: string;
  };
  pagamento: {
    id: number;
    status: string;
    linkPagamento: string;
  };
  whatsapp?: {
    tentado: boolean;
    enviado: boolean;
    mensagemId?: number;
    statusMensagem?: string;
  };
};

export const reenviarWhatsappAssinaturaService = async (
  assinaturaId: number
): Promise<ReenviarWhatsappAssinaturaResponse> => {
  const token = validateToken();

  if (!token) {
    throw new Error("Sessao expirada. Faca login novamente.");
  }

  const url = `${Globais.DOMINIOBACK}/assinatura/${assinaturaId}/enviar-whatsapp`;

  const response = await axios.post<ReenviarWhatsappAssinaturaResponse>(
    url,
    null,
    {
      headers: { Authorization: token.AuthStr },
    }
  );

  return response.data;
};
